import React, { createContext, useState, useEffect, useReducer } from "react"
import ecomCart from "@ecomplus/shopping-cart"

const ACTIONS = {
  CART_UPDATE: "cartUpdate",
  CART_CLEAR: "cartClear",
  CART_ADD_ITEM: "cartAddItem",
  CART_REMOVE_ITEM: "cartRemoveItem",
  CART_UPDATE_ITEM: "cartUpdateItem",
  CART_ITEM_INCREASE_QNT: "increaseQuantity",
  CART_ITEM_DECREASE_QNT: "decreaseQuantity",
  SIDEBAR_IS_OPEN: "sidebarIsOpen",
  MENU_IS_OPEN: "menuIsOpen",
  LOCATION_CHANGE: "locationChange",
  SET_THE_DEFAULT: "setTheDefault",
  LOCATION_ADD: "locationAdd",
  LOCATIONS_CLEAR: "locationClear",
  DATETIME_ADD: "dateTimeAdd",
  DATETIMES_CLEAR: "dateTimeClear",
}

const CartReducer = (state, action) => {
  const handleItemQuantity = ({ item, hasAction }, factor) => {
    const cartItem = state.filter(cartItem => cartItem._id === item._id)[0]
    switch (true) {
      case cartItem && cartItem.quantity === 1 && factor < 0 && hasAction:
        ecomCart.removeItem(item._id)
        break
      case !cartItem && factor > 0:
        item.quantity = 1
        ecomCart.addItem(item)
        break
      default:
        ecomCart.increaseItemQnt(item._id, factor)
    }
  }

  switch (action.type) {
    case ACTIONS.CART_ADD_ITEM:
      ecomCart.addItem(action.payload)
      break

    case ACTIONS.CART_UPDATE_ITEM:
      ecomCart.data.items = ecomCart.data.items.map(item => {
        return item._id === action.payload._id ? action.payload : item
      })
      ecomCart.save()
      return ecomCart.data.items

    case ACTIONS.CART_REMOVE_ITEM:
      ecomCart.removeItem(action.payload)
      break

    case ACTIONS.CART_ITEM_INCREASE_QNT:
      handleItemQuantity(action.payload, 1)
      break

    case ACTIONS.CART_ITEM_DECREASE_QNT:
      handleItemQuantity(action.payload, -1)
      break

    case ACTIONS.CART_UPDATE:
      return action.payload

    case ACTIONS.CART_CLEAR:
      ecomCart.clear()
      return []

    case ACTIONS.LOCATION_CHANGE:
      const idx = state.findIndex(
        item => action.payload.item._id.toString() === item._id.toString()
      )
      const temp = [...state]
      if (idx >= 0) {
        temp[idx][action.payload.value] = action.payload.address
        console.log("InCart:", idx, temp[idx] === state[idx])
      }
      return temp

    default:
      return state
  }

  return state
}

const SidebarReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SIDEBAR_IS_OPEN:
      return {
        ...state,
        sidebar: action.payload
      }
    case ACTIONS.MENU_IS_OPEN:
      return {
        ...state,
        menu: action.payload
      }
    default:
      return state
  }
}

const LocationsReducer = (state, action) => {
  const newState = { ...state }

  switch (action.type) {
    case ACTIONS.SET_THE_DEFAULT:
      let currentDefault = newState.default_location
      let newDefault = action.payload[1]
      let newDefaultId = action.payload[0]

      if (currentDefault) {
        let newId = currentDefault.nickname.replace(/[\W]/g, "_").toLowerCase()
        newState[newId] = { ...currentDefault }
      }
      newState.default_location = { ...newDefault }
      delete newState[newDefaultId]

      return { ...newState }

    case ACTIONS.LOCATION_ADD:
      const key = action.payload.isDefault
        ? "default_location"
        : action.payload.location.nickname.replace(/[\W]/g, "_").toLowerCase()

      newState[key] = { ...action.payload.location }

      return { ...newState }

    case ACTIONS.LOCATIONS_CLEAR:
      return { default_location: {} }
  }
}

const DateTimesReducer = (state, action) => {
  const newState = { ...state }
  const key = action?.payload?.isDefault === false
    ? action.payload.date.getTime()
    : "default_dateTime"

  switch (action.type) {
    case ACTIONS.SET_THE_DEFAULT:
      let currentDefault = newState.default_dateTime
      let newDefault = action.payload.date
      let newDefaultId = action.payload.date.getTime()

      if (currentDefault) {
        newState[currentDefault.getTime()] = currentDefault
      }
      newState.default_dateTime = newDefault
      delete newState[newDefaultId]

      return { ...newState }

    case ACTIONS.DATETIME_ADD:
      newState[key] = action.payload.date
      return { ...newState }

    case ACTIONS.DATETIMES_CLEAR:
      return {}
  }
}

const CartContext = createContext({})

const defaultLocations = {
  // "default_location": {
  //   nickname: "Crossing Location",
  //   address: "4 Abbey Rd, London NW8 0AH, UK",
  //   fullAddress: {
  //     "address line 1": 4,
  //     "address line 2": "Abbey Road",
  //     "address line 4": "London",
  //     "address line 7": "United Kingdom",
  //     "address line 8": "NW8 0AH",
  //   },
  // },
  // "this_is_undefined": {
  //   nickname: "This Is Undefined",
  //   address: "35-37 Bow Road, London E3 2AD, UK",
  //   fullAddress: {
  //     "address line 1": 35,
  //     "address line 2": "Bow Road",
  //     "address line 4": "London",
  //     "address line 7": "United Kingdom",
  //     "address line 8": "E3 2AD",
  //   },
  // },
}

const defaultTime = {
  // "1619162100000": new Date( "2021-04-23T09:15:00.000" ),
  // "1619164800000": new Date( "2021-04-23T10:00:00.000" ),
}

const CartProvider = ({ children }) => {
  const [cartData, dispatchCart] = useReducer(CartReducer, ecomCart.data.items)
  const [locations, dispatchLocations] = useReducer(
    LocationsReducer,
    defaultLocations
  )
  const [dateTimes, dispatchDateTimes] = useReducer(
    DateTimesReducer,
    defaultTime
  )
  const [ sidebarIsOpen, dispatchSidebar ] = useReducer(
    SidebarReducer,
    {
      menu: false,
      sidebar: false
    }
  )

  const [loading /*, setLoading*/] = useState(true)
  const [cartUpdatedOn, setCartUpdatedOn] = useState(null)
  const [notes, setNotes] = useState([])
  const [count, setCount] = useState([])

  const onCartChange = async ({ data }) => {
    const result = await data.items

    setCartUpdatedOn(new Date().toString())
    dispatchCart({ type: ACTIONS.CART_UPDATE, payload: result })
  }

  useEffect(() => {
    ecomCart.on("change", onCartChange)
    return () => {
      ecomCart.off("change", onCartChange)
    }
  }, [])

  const openNotesEditor = itemId => {
    setNotes({
      ...notes,
      [itemId]: !notes[itemId],
    })
  }

  const closeNotesEditor = itemId => {
    setNotes({
      ...notes,
      [itemId]: false,
    })
  }

  const addCartItemNotes = e => {
    const elem = e.currentTarget.parentElement.parentElement.parentElement.querySelector(
      `textarea`
    )
    const item = cartData.filter(cartItem => cartItem._id === elem.id)[0]
    item.notes = elem.value
    closeNotesEditor(elem.id)
  }

  const clearCartItemNote = e => {
    const elem = e.currentTarget.parentElement.parentElement.parentElement.querySelector(
      `textarea`
    )
    const item = cartData.filter(cartItem => cartItem._id === elem.id)[0]
    if (item && item.notes) item.notes = ""
    elem.value = ""
  }

  return (
    <CartContext.Provider
      value={{
        loading,
        cartData,
        cartUpdatedOn,
        sidebarIsOpen,
        locations,
        dateTimes,
        notes,
        count,
        setCount,
        dispatchCart,
        dispatchSidebar,
        dispatchLocations,
        dispatchDateTimes,

        addCartItemNotes,
        clearCartItemNote,
        openNotesEditor,
        closeNotesEditor,

        ACTIONS,
      }}
    >
      {children}
    </CartContext.Provider>
  )
}

export { CartContext, CartProvider }
